<template>
  <div class="data_brain_wrap">
    <el-row class="card_wrap" type="flex">
      <div
        style="
          display: flex;
          width: 100%;
          height: 100%;
          align-items: center;
          justify-content: center;
        ">
        <div
          style="
            width: 60%;
            height: 100%;
            background-color: #fff;
            position: relative;
            margin-right: 2vw;
          ">
          <div class="page-content">
            <!-- <div class="fenlei">
              <div
                v-for="(item, index) in articleType"
                :key="index"
                class="fenleilist">
                {{ item.name }}
              </div>
            </div> -->

            <div style="height: 55%; width: 100%">
              <el-carousel>
                <el-carousel-item v-for="(item, index) in ad1" :key="index">
                  <!-- <h3 class="small">{{ item }}</h3> -->
                  <a :href="item.link">
                    <img
                      :src="item.pic"
                      alt=""
                      style="width: 100%; height: 100%" />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div style="width: 100%; height: 44%; padding: 20px">
              <!-- <el-carousel>
                <el-carousel-item v-for="(item, index) in ad6" :key="index">
                  <img
                    :src="item.pic"
                    alt=""
                    style="width: 100%; height: 100%" />
                </el-carousel-item>
              </el-carousel> -->
              <h2 style="color: #111">热门搜索</h2>
              <div style="width: 50%; margin: 0 auto; margin-top: 1vw">
                <el-input
                  placeholder="请输入内容"
                  suffix-icon="el-icon-search"
                  v-model="input"
                  @change="searchlist"></el-input>
              </div>
              <div
                style="
                  width: 82%;
                  display: flex;
                  flex-wrap: wrap;
                  justify-content: space-between;
                  margin: 50px auto 0px auto;
                  height: 60%;
                ">
                <div
                  v-for="(item, index) in types"
                  :key="index"
                  style="
                    width: 32%;
                    height: 2vw;
                    text-align: center;
                    background-color: #f2f3f5;
                    border-radius: 0.2vw;
                    line-height: 2vw;
                    cursor: pointer;
                    color: #111;
                    font-weight: 700;
                    font-size: 1.9ch;
                  "
                  @click="toserch(item)">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width:22%;height:100%;display: flex;flex-direction: column;justify-content: space-between;">
          <memberCenter style="width:100%;height:55%;"></memberCenter>
          <div
            style="
              width: 100%;
              height: 44%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            ">
            <div style="height: 22%; width: 100%">
              <el-carousel indicator-position="none">
                <el-carousel-item v-for="(item2, index2) in ad2" :key="index2">
                  <!-- <h3 class="small">{{ item }}</h3> -->
                  <a :href="item2.link">
                    <img
                      :src="item2.pic"
                      alt=""
                      style="width: 100%; height: 100%" />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div style="height: 22%; width: 100%">
              <el-carousel indicator-position="none">
                <el-carousel-item v-for="(item3, index3) in ad3" :key="index3">
                  <!-- <h3 class="small">{{ item }}</h3> -->
                  <a :href="item3.link">
                    <img
                      :src="item3.pic"
                      alt=""
                      style="width: 100%; height: 100%" />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>

            <div style="height: 22%; width: 100%">
              <el-carousel indicator-position="none">
                <el-carousel-item v-for="(item4, index4) in ad4" :key="index4">
                  <!-- <h3 class="small">{{ item }}</h3> -->
                  <a :href="item4.link">
                    <img
                      :src="item4.pic"
                      alt=""
                      style="width: 100%; height: 100%" />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div style="height: 22%; width: 100%">
              <el-carousel indicator-position="none">
                <el-carousel-item v-for="(item5, index5) in ad5" :key="index5">
                  <!-- <h3 class="small">{{ item }}</h3> -->
                  <a :href="item5.link">
                    <img
                      :src="item5.pic"
                      alt=""
                      style="width: 100%; height: 100%" />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getArticle,
  AdList,
  getHyTypes,
} from "@/api/user.js";
import memberCenter from "@/components/memberCenter/memberCenter.vue";
let settoken = null;
export default {
  components:{memberCenter},
  data() {
    return {
      currentPage: 1,
      pageSize: 6, // 每页显示的卡片数量
      // 所有数据
      // allData: [],
      // articleType: [],
      // cid: 0,
      ad1: [],
      ad2: [],
      ad3: [],
      ad4: [],
      ad5: [],
      ad6: [],
      types: [],
      input: "",
    };
  },
  computed: {
    isToken() {
        if (localStorage.getItem("token") && localStorage.getItem("token") != 'undefined' && localStorage.getItem("token").trim() != '') {
            return true
        } else {
            return false
        }
    },
    // total() {
    //   return this.allData.length;
    // },
    // // 计算当前页面要显示的数据
    // currentPageContent() {
    //   const start = (this.currentPage - 1) * this.pageSize;
    //   const end = start + this.pageSize;
    //   return this.allData.slice(start, end);
    // },
  },
  created() {
    this.getdata();
  },
  methods: {
    searchlist() {
      let data = {
        input:this.input
      }
      // 触发自定义事件，将数据传递给父组件
      this.$emit("sendData", data);
      // this.getdata(); // 如果不需要本地刷新可以去掉
    },
    toserch(item) {
      this.input = item.name;
      let data = {
        input:'',
        labelId:item.id
      }
      this.$emit("sendData", data);
    },
    getdata() {
      const that = this;
      console.log('this.isToken',this.isToken)
      if(this.isToken){
        getHyTypes().then((res) => {
          console.log("行业报告类型", res);
          that.types = res.data;
        });
      }
      // getArticle({ cid: that.cid }).then((res) => {
      //   console.log(res);
      //   that.allData = res.data;
      //   that.articleType = res.clist;
      // });
      AdList(
        ['REPORT-AD-1','REPORT-AD-2','REPORT-AD-3','REPORT-AD-4','REPORT-AD-5','REPORT-AD-6']
      ).then((res) => {
        console.log('resres',res);
        that.ad1 = res.data['REPORT-AD-1'].data?JSON.parse(res.data['REPORT-AD-1'].data):[];
        that.ad2 = res.data['REPORT-AD-2'].data?JSON.parse(res.data['REPORT-AD-2'].data):[];
        that.ad3 = res.data['REPORT-AD-3'].data?JSON.parse(res.data['REPORT-AD-3'].data):[];
        that.ad4 = res.data['REPORT-AD-4'].data?JSON.parse(res.data['REPORT-AD-4'].data):[];
        that.ad5 = res.data['REPORT-AD-5'].data?JSON.parse(res.data['REPORT-AD-5'].data):[];
        that.ad6 = res.data['REPORT-AD-6'].data?JSON.parse(res.data['REPORT-AD-6'].data):[];
      });
    },
    // 处理每页显示条目数变化
    handleSizeChange(newSize) {
      this.pageSize = newSize;
    },
    // 处理当前页码变化
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
    },
    handleNavigate() {
      this.$router.push("/production/1").catch((v) => {
        console.log(v);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.data_brain_wrap {
  padding: 70px 0;
  background: #e8eef2;
  // text-align: center;
  .brain_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40px;
    }
  }
  ::v-deep .el-carousel {
    height: 100%;

    .el-carousel__container {
      height: 100%;
    }
  }
  .card_wrap {
    width: 80%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-between;
    height: 900px;
    border-radius: 8px;
    position: relative;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    ::v-deep .el-carousel {
      height: 100%;

      .el-carousel__container {
        height: 100%;
      }
    }
    .page-content {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .fenlei {
        width: 100%;
        padding: 20px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .fenleilist {
          height: 2.5vw;
          width: 6vw;
          text-align: center;
          line-height: 2.5vw;
          background-color: #0d067e;
          color: #fff;
          border-radius: 5px;
          cursor: pointer;
        }
      }
    }
    .ggw {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 10%;
      width: 4%;
      margin-right: 1%;
    }
    .top-left {
      height: 100%;
      width: 20%;
      background-color: #0d067e;
      display: flex;
      flex-direction: column;
      border-radius: 6px;
      .top-left-title {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        color: #fff;
        padding: 10px 20px;
        font-weight: 700;
        font-size: 16px;
      }
      .top-left-info {
        width: 100%;
        flex: 1;
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;
        background-color: #fff;
        padding: 30px 20px;
        overflow-y: scroll;
        -ms-overflow-style: none; /* IE 和 Edge */
        scrollbar-width: none; /* Firefox */
      }
      .scrollable-container::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }
    }
    .top-center {
      height: 100%;
      width: 50%;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
    }
    .brain_item {
      transition: background-color 1s;
      padding: 30px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40px;
        border-radius: 10px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20px;
        &:nth-child(-n + 2) {
          margin-top: 0;
        }
      }
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;
      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          134deg,
          #0649b8 1%,
          #0a7fd7 41%,
          #03d2c5 99%
        );
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }
      &:hover .item_bg {
        opacity: 1;
      }
      &:hover .item_title {
        color: #fff;
      }
      &:hover .item_desc {
        color: #fff;
      }
      .item_title {
        transition: all 0.5s;
        font-size: 30px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 20px 0 40px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }
      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 18px;
        min-height: 110px;
        @media screen and (max-width: 768px) {
          min-height: 110px;
          text-indent: 2em;
          font-size: 12px;
        }
      }
      .item_navigate {
        width: 100px;
        height: 30px;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
